import { render, staticRenderFns } from "./TrashBinIcon.vue?vue&type=template&id=2a328242&scoped=true&"
import script from "./TrashBinIcon.vue?vue&type=script&lang=js&"
export * from "./TrashBinIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrashBinIcon.vue?vue&type=style&index=0&id=2a328242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a328242",
  null
  
)

export default component.exports